import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';

@Component({
    selector: 'app-question-year',
    templateUrl: './question-year.component.html',
    styleUrls: ['./question-year.component.scss'],
    standalone: false
})
export class QuestionYearComponent implements OnInit {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = false;
  @Input() isIdInput = false;
  @Input() editModal = false;
  @Output() questionAnswer = new EventEmitter();

  uniqueControlName = `textbox-${newGuid()}`;
  uniqueId = `textbox-${newGuid()}`;
  value = '';

  constructor() {
  }

  ngOnInit(): void {
    if (this.question?.answer) {
      this.value = this.question.answer;
    }
  }

  noregNumber(): void {
    this.value = 'TBC ' + this.question.item_id;
    this.saveValue();
  }

  upperCase(): void {
    if (this.question.cent_aq_question_id === 57) {
      this.value = this.value.toUpperCase();
    }
  }

  saveValue(): void {
    if (this.value.length === 4) {
      console.log(this.value);
      const current_year = new Date().getFullYear();
      if ((Number(this.value) < 1920) || (Number(this.value) > current_year)) {
        this.value = '';
        return;
      }
      this.question.answer = this.value;
      this.questionAnswer.emit(this.question);
    }

  }

}
